import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = ({ phoneNumber = "1234567890", message = "Hi, I'm interested in AiFlo.ai services" }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    // Format phone number (remove any non-numeric characters)
    const formattedPhone = phoneNumber.replace(/\D/g, '');
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);
    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
    // Open in new tab
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      {/* Main WhatsApp Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full shadow-2xl hover:scale-110 transition-all duration-300 flex items-center justify-center group"
        aria-label="Chat on WhatsApp"
      >
        {/* Pulsing ring effect */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75" />
        
        {/* WhatsApp Icon */}
        <MessageCircle className="w-8 h-8 relative z-10" />
        
        {/* Glow effect */}
        <div className="absolute inset-0 bg-green-400/50 rounded-full blur-xl group-hover:bg-green-400/70 transition-all" />
      </button>

      {/* Tooltip on hover */}
      {isHovered && (
        <div className="fixed bottom-24 right-6 z-50 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl whitespace-nowrap animate-fade-in">
          Chat with us on WhatsApp
          <div className="absolute bottom-0 right-8 transform translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900" />
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
